import { useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { createCost } from "../../api/contract/cost";
import AttachmentBox from "../../components/common/papers/AttachmentBox";

const Cost_new = ({ isOpen, onClose, onCreated }) => {
  const { id: projectId } = useParams();
  const [form, setForm] = useState({
    project: projectId,
    code: "",
    construction_type: "본공사",
    payment_date: "",
    expected_amount: "",
    actual_amount: "",
    memo: "",
  });
  const [loading, setLoading] = useState(false);
  const attachmentRef = useRef(null); //파일관련 변수

  if (!isOpen) return null;

  const isFormValid = () => {
    return (
      form.code.trim() !== "" &&
      form.payment_date.trim() !== "" &&
      form.expected_amount.trim() !== "" &&
      form.actual_amount.trim() !== ""
    );
  };

  // 입력 핸들러
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // 금액 입력 (숫자만)
  const handleAmountChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");
    setForm((prev) => ({ ...prev, [name]: numericValue }));
  };

  // 저장
  const handleSubmit = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("project", projectId);

      Object.entries(form).forEach(([key, value]) =>
        formData.append(key, value ?? "")
      );

      const newCost = await createCost(formData);

      try {
        await attachmentRef.current?.save(newCost.dns);
      } catch (e) {
        console.warn("attachment 저장 에러 (비치명적):", e);
      }
      if (onCreated) onCreated(newCost.dns);
      onClose();
    } catch (err) {
      console.error("기성 입력 실패:", err);
      const message =
        err.response?.data?.detail || "저장에 실패했습니다. 다시 시도해주세요.";
      alert(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-lg p-6 animate-fadeIn">
        <h2 className="text-xl font-semibold mb-4 text-gray-800">
          기성(수동) 입력
        </h2>

        <div className="space-y-4">
          {/* 코드 */}
          <div>
            <label className="block text-sm font-medium mb-1">코드</label>
            <input
              type="text"
              name="code"
              value={form.code}
              onChange={handleChange}
              className="w-full border rounded-md px-3 py-2"
            />
          </div>

          {/* 공종 */}
          <div>
            <label className="block text-sm font-medium mb-1">공종</label>
            <input
              type="text"
              name="construction_type"
              value={form.construction_type}
              onChange={handleChange}
              className="w-full border rounded-md px-3 py-2"
              placeholder="공종을 입력하세요"
            />
          </div>

          {/* 단위 */}
          <div>
            <label className="block text-sm font-medium mb-1">지불 날짜</label>
            <input
              type="date"
              name="payment_date"
              value={form.payment_date}
              onChange={handleChange}
              className="w-full border rounded-md px-3 py-2"
            />
          </div>

          {/* 계획 금액 */}
          <div>
            <label className="block text-sm font-medium mb-1">계획 금액</label>
            <input
              type="text"
              name="expected_amount"
              value={form.expected_amount}
              onChange={handleAmountChange}
              className="w-full border rounded-md px-3 py-2 text-right"
            />
          </div>

          {/* 실제 금액 */}
          <div>
            <label className="block text-sm font-medium mb-1">실제 금액</label>
            <input
              type="text"
              name="actual_amount"
              value={form.actual_amount}
              onChange={handleAmountChange}
              className="w-full border rounded-md px-3 py-2 text-right"
            />
          </div>

          {/* 메모 */}
          <div>
            <label className="block text-sm font-medium mb-1">메모</label>
            <textarea
              name="memo"
              value={form.memo}
              onChange={handleChange}
              className="w-full border rounded-md px-3 py-2"
            />
          </div>

          {/* 파일 업로드 (다중) */}
          <AttachmentBox ref={attachmentRef} />
        </div>

        {/* 버튼 */}
        <div className="mt-6 flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
          >
            취소
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading || !isFormValid()}
            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 
                      disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            {loading ? "저장 중..." : "저장"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cost_new;
